const url = 'http://39.102.204.93'
export default {
  url
}



// WEBPACK FOOTER //
// ./src/assets/public/url.js